import React from 'react';
import ConfirmEmail from '@jumbo/components/Common/authComponents/ConfirmEmail';

const ConfirmUserEmail = () => <ConfirmEmail variant="standard" wrapperVariant="bgColor" />;

export default ConfirmUserEmail;
